<template>
  <div @click="toggleClick">
    <i :class="toggleClass"></i>
  </div>
</template>

<script>
export default {
  name: 'hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  },
  computed: {
    toggleClass() {
      if (this.isActive) {
        return 'el-icon-s-fold';
      } else {
        return 'el-icon-s-unfold';
      }
    }
  }
};
</script>

<style scoped>
.hamburger {
  display: inline-block;
  width: 20px;
  height: 20px;
}
.hamburger-title {
  display: inline-block;
  font-weight: 800;
  padding: 0 10px;
}

.hamburger.is-active {
}
</style>



// WEBPACK FOOTER //
// src/components/Hamburger/index.vue